var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"font-size-14",attrs:{"flat":"","dense":"","outlined":"","hide-details":"","append-icon":"mdi-chevron-down","value":_vm.priority,"items":_vm.priorities,"label":_vm.$t('common.priority'),"placeholder":_vm.$t('common.select')},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }